<template>
  <el-container class="default-layout">
    <the-aside/>
    <el-container class="main-container">
      <el-header height="auto">
        <the-header/>
      </el-header>
      <div
          :class="[
          'page-main-wrapper',
          leftMenuVisible ? '' : 'page-main-wrapper_left-hidden',
        ]"
      >

        <portal-target
            ref="leftMenu"
            name="layout_left_menu"
            class="page-main-wrapper__left-panel"
        ></portal-target>
        <div v-loading="loading" class="page-main-wrapper__content" :style="backgroundColor">
          <portal-target
              name="layout_nav_items"
          ></portal-target>
          <el-main
              :style="{  paddingBottom: '20px' }"
              class="main-block"
              id="main-block"
          >
            <div style="width: 100%;">
              <transition name="fade" mode="out-in">
                <router-view/>
              </transition>
            </div>
          </el-main>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import {mapState} from "vuex";
import TheAside from "../components/TheAside";
import TheHeader from "../components/TheHeader";

export default {
  name: "default",
  components: {
    TheHeader,
    TheAside,
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapState("loader", {
      loading: (state) => state.loading,
    }),
    leftMenuVisible() {
      return 0
    },
    backgroundColor() {
      return {
        background: this.$route.name === 'cpanel.dashboard' ? '#fff' : ''
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss">
.main-container {
  height: 100%;

  @media only screen and (max-width: 500px) {
    display: block;
  }
}

.main-block {
  padding: 0;
}

.default-layout {
  height: 100vh;
  background: #fff;

  .el-main {
    padding-bottom: 0 !important;
    position: relative;
  }

  .infinite-status-prompt {
    font-size: 25px;
    margin-top: 25px;
    color: #e0e0e0;
  }

  .page-main-wrapper {
    flex-direction: row;
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: auto;

    &__left-panel {
      flex: 0 200px;
      background: #f6f5f3;
      position: relative;
      min-width: 200px;
      overflow: auto;
    }

    &__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 200px);

      background: #f6f8f9;
    }

    &_left-hidden {
      .page-main-wrapper__left-panel {
        flex: 0;
        min-width: auto;
      }

      .page-main-wrapper__content {
        max-width: 100%;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>